export default __webpack_public_path__ + "static/media/ify.21da64bc.jpeg";